
import React, { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, Form } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { FormValues } from "./types";
import { useAuth } from "@/lib/hooks/auth";

interface PersonalDetailsSectionProps {
  form: UseFormReturn<FormValues>;
}

export const PersonalDetailsSection: React.FC<PersonalDetailsSectionProps> = ({ form }) => {
  const { user } = useAuth();
  
  // Effect to update form values when user data changes
  useEffect(() => {
    if (user) {
      console.log("Updating PersonalDetailsSection with user data:", {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phone: user.phone
      });
      
      // Only update fields that have values and don't overwrite user input if fields are already filled
      const currentValues = form.getValues();
      const updates: Partial<FormValues> = {};
      
      if (user.firstName && !currentValues.firstName) updates.firstName = user.firstName;
      if (user.lastName && !currentValues.lastName) updates.lastName = user.lastName;
      if (user.email && !currentValues.email) updates.email = user.email;
      if (user.phone && !currentValues.phone) updates.phone = user.phone;
      
      if (Object.keys(updates).length > 0) {
        form.setValue("firstName", updates.firstName || currentValues.firstName);
        form.setValue("lastName", updates.lastName || currentValues.lastName);
        form.setValue("email", updates.email || currentValues.email);
        form.setValue("phone", updates.phone || currentValues.phone);
      }
    }
  }, [user, form]);

  return (
    <Form {...form}>
      <div className="grid grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="firstName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>First Name</FormLabel>
              <FormControl>
                <Input placeholder="Enter your first name" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="lastName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Last Name</FormLabel>
              <FormControl>
                <Input placeholder="Enter your last name" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Email</FormLabel>
            <FormControl>
              <Input type="email" placeholder="Enter your email" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="phone"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Phone Number</FormLabel>
            <FormControl>
              <Input placeholder="Enter your phone number" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </Form>
  );
};
